import { render } from "./5.vue?vue&type=template&id=590e708a&scoped=true"
import script from "./5.vue?vue&type=script&lang=js"
export * from "./5.vue?vue&type=script&lang=js"

import "./5.vue?vue&type=style&index=0&id=590e708a&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-590e708a"]])

export default __exports__